import { z } from "zod";
import { baseEntitySchema } from "./base";

export const salesOrderStatusSchema = z.enum([
  "draft",
  "allocated",
  "open_booking",
  "ticketed",
  "delivered",
  "cancelled",
]);
export type SalesOrderStatus = z.infer<typeof salesOrderStatusSchema>;

/**
 * Whether a sell order in this status has its miles taken out of inventory.
 * Drafts are still waiting on admin approval; cancelled orders gave theirs back.
 */
export function salesOrderHoldsInventory(status: SalesOrderStatus): boolean {
  return status !== "draft" && status !== "cancelled";
}

export const salesChannelSchema = z.enum(["hubspot", "manual", "agent", "other"]);
export type SalesChannel = z.infer<typeof salesChannelSchema>;

export const salesOrderDataSchema = z.object({
  inventoryId: z.string(),
  clientId: z.string().optional(),
  clientDisplayName: z.string().optional(),
  clientEmail: z.string().optional(),
  flightDate: z.date().optional(),
  soldByUserId: z.string().optional(),
  soldByUserEmail: z.string().email().optional(),
  bookingEndDate: z.date().optional(),
  bookingTbd: z.boolean().optional(),
  purchaseDate: z.date().optional(),
  productId: z.string(),
  productName: z.string(),
  sourceDealId: z.string().optional(),
  candidateId: z.string().optional(),
  status: salesOrderStatusSchema,
  totalMilesSold: z.number().nonnegative(),
  revenue: z.number().nonnegative(),
  taxCost: z.number().nonnegative().optional(),
  totalAmount: z.number().nonnegative().optional(),
  salesChannel: salesChannelSchema,
  notes: z.string().optional(),
  invoiceIds: z.array(z.string()).default([]),
  specialAttributeIds: z.array(z.string()).default([]),
  transferProductId: z.string().optional(),
});

export type SalesOrderData = z.infer<typeof salesOrderDataSchema>;
export const salesOrderSchema = baseEntitySchema.merge(salesOrderDataSchema);
export type SalesOrder = z.infer<typeof salesOrderSchema>;
